import {
  GET_SERVICES_CATEGORY_FAIL,
  GET_SERVICES_CATEGORY_REQUEST,
  GET_SERVICES_CATEGORY_SUCCESS,
  ADD_SERVICE_CATEGORY_FAIL,
  ADD_SERVICE_CATEGORY_REQUEST,
  ADD_SERVICE_CATEGORY_SUCCESS,
  EDIT_SERVICE_CATEGORY_FAIL,
  EDIT_SERVICE_CATEGORY_REQUEST,
  EDIT_SERVICE_CATEGORY_SUCCESS,
  DELETE_SERVICE_CATEGORY_FAIL,
  DELETE_SERVICE_CATEGORY_REQUEST,
  DELETE_SERVICE_CATEGORY_SUCCESS
} from "./actions";
import { IServiceCategory } from "app/api/types";

interface IState {
  isLoading: boolean;
  serviceCategoriesList: IServiceCategory[];
}
const initialState: IState = {
  serviceCategoriesList: [],
  isLoading: false
};

const serviceCategoriesReducer = (
  state = initialState,
  action: { type: any; payload: any }
) => {
  switch (action.type) {
    case GET_SERVICES_CATEGORY_REQUEST:
    case EDIT_SERVICE_CATEGORY_REQUEST:
    case ADD_SERVICE_CATEGORY_REQUEST:
      return {
        ...state,
        isLoading: true
      };

    case DELETE_SERVICE_CATEGORY_REQUEST:
      return {
        ...state
      };

    case ADD_SERVICE_CATEGORY_FAIL:
    case GET_SERVICES_CATEGORY_FAIL:
    case EDIT_SERVICE_CATEGORY_FAIL:
      return {
        ...state,
        isLoading: false
      };

    case DELETE_SERVICE_CATEGORY_FAIL:
      return {
        ...state,
        isLoading: false
      };

    case GET_SERVICES_CATEGORY_SUCCESS:
      return {
        ...state,
        serviceCategoriesList: action.payload,
        isLoading: false
      };

    case ADD_SERVICE_CATEGORY_SUCCESS:
    case EDIT_SERVICE_CATEGORY_SUCCESS:
      return {
        ...state,
        isLoading: false
      };

    case DELETE_SERVICE_CATEGORY_SUCCESS:
      return {
        ...state,
        isLoading: true
      };
    default:
      return state;
  }
};

export default serviceCategoriesReducer;
